import { ResidencyType } from "./doctor.definition";

export type AcceptedCountries =
  (typeof AcceptedCountriesEnum)[keyof typeof AcceptedCountriesEnum];
export const AcceptedCountriesEnum = {
  SENEGAL: "SENEGAL",
  CHAD: "CHAD",
};
export type UserInfo = {
  id?: string;
  photoUrl?: string;
  email: string;
  civility: CivilityType;
  roleName: RoleType;
  firstName: string;
  phoneNumber: string;
  lastName: string;
  paymentPhoneNumber?: string;
  preferredNotificationMethods: NotificationPrefType[];
  dateOfBirth?: string;
  location?: Location; // Keep for backward compatibility
  locations?: Location[]; // New: array of locations
  requiresPasswordChange?: boolean;
};

export type Location = {
  id?: number; // Location ID for existing locations (to avoid duplicates on update)
  address?: string;
  city?: string;
  country?: AcceptedCountries;
  state?: string;
  zip?: string;
  residency?: ResidencyType;
  isPrimary?: boolean;
  coordinates?: {
    lat: number;
    lng: number;
  } | null;
  accessInformation?: string;
};

export type CivilityType = (typeof CivilityEnum)[keyof typeof CivilityEnum];

export const CivilityEnum = {
  MRS: "WOMAN",
  MR: "MAN",
};

export type NotificationPrefType =
  (typeof NotificationPrefEnum)[keyof typeof NotificationPrefEnum];

export const NotificationPrefEnum = {
  SMS: "SMS",
  EMAIL: "EMAIL",
};
export const RoleEnum = {
  ADMIN: "ADMIN",
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
  MANAGER: "MANAGER",
  SUPER_ADMIN: "SUPER_ADMIN",
  SECRETARY: "SECRETARY",
} as const;

// Namespace merging: allows RoleEnum.DOCTOR to be used as a type
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RoleEnum {
  export type ADMIN = typeof RoleEnum.ADMIN;
  export type PATIENT = typeof RoleEnum.PATIENT;
  export type DOCTOR = typeof RoleEnum.DOCTOR;
  export type MANAGER = typeof RoleEnum.MANAGER;
  export type SUPER_ADMIN = typeof RoleEnum.SUPER_ADMIN;
  export type SECRETARY = typeof RoleEnum.SECRETARY;
}

export type RoleType = (typeof RoleEnum)[keyof typeof RoleEnum];
export type EditableUserInfo = Omit<
  UserInfo,
  "preferredNotificationMethods"
> & {
  preferredNotificationMethods: {
    value: NotificationPrefType;
    label: NotificationPrefType;
  }[];
};
